module.exports = __webpack_public_path__ + "img/instagram.54d7b353.svg";